import { render, staticRenderFns } from "./VehicleLaidUp.vue?vue&type=template&id=6b3797c6"
import script from "./VehicleLaidUp.vue?vue&type=script&lang=js"
export * from "./VehicleLaidUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports